import {
  SITE_SEARCH_REQUEST_COMMON,
  SITE_SEARCH_SUCCESS_COMMON,
  SITE_SEARCH_FAILURE_COMMON,
  CREATE_SYSTEM_REQUEST_COMMON,
  CREATE_SYSTEM_SUCCESS_COMMON,
  CREATE_SYSTEM_FAILURE_COMMON,
  GET_SITE_DETAILS,
  GET_SITE_DETAILS_SUCCESS,
  GET_SITE_DETAILS_FAILURE,
} from './constants';

let initialState = {
  message: '',
  messageType: '',
  currentlySending: false,
  siteSearchInProgress: false,
  searchResults: { total_count: 0, result: [] },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SITE_SEARCH_REQUEST_COMMON:
      return { ...state, siteSearchInProgress: true };
    case SITE_SEARCH_SUCCESS_COMMON:
      return {
        ...state,
        siteSearchInProgress: false,
        searchResults: action.searchList,
      };
    case SITE_SEARCH_FAILURE_COMMON:
      return {
        ...state,
        siteSearchInProgress: false,
        messageType: 'error',
        message: action.error,
      };
    case GET_SITE_DETAILS:
      return {
        ...state,
        currentlySending: true,
      };
    case GET_SITE_DETAILS_SUCCESS:
    case GET_SITE_DETAILS_FAILURE:
      return {
        ...state,
        currentlySending: false,
      };
    case CREATE_SYSTEM_REQUEST_COMMON:
      return { ...state, currentlySending: true };
    case CREATE_SYSTEM_SUCCESS_COMMON:
      return { ...state, currentlySending: false, message: '', messageType: '' };
    case CREATE_SYSTEM_FAILURE_COMMON:
      return {
        ...state,
        currentlySending: false,
        messageType: 'error',
        message: action.error,
      };
    default:
      return state;
  }
}

export default reducer;
